export default __webpack_public_path__ + "static/media/content-img.24e6ca9e.webp";